function loadCSSAsync(href) {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'screen'; // Keep the original media attribute
    link.crossOrigin = 'anonymous'; // Keep the original crossorigin attribute
    link.onload = () => resolve(); // Resolve the Promise when loaded
    link.onerror = () => reject(); // Reject if there's an error
    link.setAttribute('data-turbolinks-permanent', ''); // Preserve on navigation

    // Preload the stylesheet (optional but recommended for faster perceived load)
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.href = href;
    preload.as = 'style';
    preload.crossOrigin = 'anonymous';
    document.head.appendChild(preload);

    // Insert the link tag after the first <style> tag or at the end of the <head>
    const firstStyle = document.querySelector('style');
    if (firstStyle) {
      firstStyle.parentNode.insertBefore(link, firstStyle.nextSibling);
    } else {
      document.head.appendChild(link);
    }
  });
}


// Find the existing link and replace it with the async version
const existingLink = document.querySelector('link[href*="accelerated-checkout-backwards-compat.css"]');

if (existingLink) {
  const href = existingLink.href;
  existingLink.remove(); // Remove the original blocking link

  loadCSSAsync(href)
    .then(() => {
      console.log('Stylesheet loaded asynchronously:', href);
    })
    .catch(error => {
      console.error('Error loading stylesheet asynchronously:', error);
    });
} else {
  console.log('Stylesheet link not found.');
}